<app-fiche-consultation
        [dataColumnsAr]="dataColumnsDocFr"
        [dataColumnsEn]="dataColumnsDocFr"
        [dataColumns]="dataColumnsDocFr"
        [data]="dataDoc"
        [label]="'Informations'"
        [labels]="labelsDoc"
        [langue]="getlang()"
>
</app-fiche-consultation>

<br/>

<app-etat-general-four
        *ngIf="dataG"
        [dataa]="dataG"
        [list]="list"
></app-etat-general-four>

<!--<mat-card  appCard style="box-shadow: 0px 6px 22px -8px rgba(0, 0, 0, 0.2) ;margin-top: 4%;">
    <mat-card-header class="titree">
        {{ "Etat Fournisseur" | translate }}
    </mat-card-header>
    <mat-card-content class="card-content">
      <div fxFlex="100" fxFlex.gt-sm="100" style="max-width: 100%;justify-content: center;">
      <app-etat-details-four [certif]="dataEtat" ></app-etat-details-four>
      </div>
      
  </mat-card-content>
  </mat-card>-->

<br/>
<app-fiche-consultation
        [dataColumnsAr]="dataColumnsArPremRes"
        [dataColumnsEn]="dataColumnsEnPremRes"
        [dataColumns]="dataColumnsPremRes"
        [data]="dataPremRes"
        [label]="'Informations Sur Premier Responsable'"
        [labels]="labelsPremRes"
        [langue]="getlang()"
>
</app-fiche-consultation>
<mat-card
        appCard
        style="box-shadow: 0px 6px 22px -8px rgba(0, 0, 0, 0.2); margin-top: 4%"
>
    <mat-card-header class="titree">
        {{ "Informations Sur Usine" | translate }}
    </mat-card-header>
    <mat-card-content class="card-content">
        <div
                fxFlex="100"
                fxFlex.gt-sm="100"
                style="max-width: 100%; justify-content: center"
        >
            <app-etat-usine-four
                    *ngIf="dataUsine"
                    [certif]="dataUsine"
            ></app-etat-usine-four>
        </div>
    </mat-card-content>
</mat-card>
<mat-card
        appCard
        style="box-shadow: 0px 6px 22px -8px rgba(0, 0, 0, 0.2); margin-top: 4%"
>
    <mat-card-header class="titree">
        {{ "Informations Classification Produits" | translate }}
    </mat-card-header>
    <mat-card-content class="card-content">
        <div
                fxFlex="100"
                fxFlex.gt-sm="100"
                style="max-width: 100%; justify-content: center"
        >
            <app-etat-classification-four
                    *ngIf="dataItemProd"
                    [certif]="dataItemProd"
            ></app-etat-classification-four>
        </div>
    </mat-card-content>
</mat-card>

<mat-card
        *ngIf="dataG[0]?.national=='TUN'"
        appCard
        style="box-shadow: 0px 6px 22px -8px rgba(0, 0, 0, 0.2); margin-top: 4%"
>
    <mat-card-header class="titree">
        {{ "Informations sur l'agrément" | translate }}
    </mat-card-header>
    <mat-card-content class="card-content">
        <div
                fxFlex="100"
                fxFlex.gt-sm="100"
                style="max-width: 100%; justify-content: center"
        >
            <app-etat-agrement-four
                    *ngIf="dataLicense"
                    [certif]="dataLicense"
            ></app-etat-agrement-four>
        </div>
    </mat-card-content>
</mat-card>
<mat-card
        appCard
        style="box-shadow: 0px 6px 22px -8px rgba(0, 0, 0, 0.2); margin-top: 4%"
>
    <mat-card-header class="titree">
        {{ "Informations Sur Mandataire Soumissionnaire" | translate }}
    </mat-card-header>
    <mat-card-content class="card-content">
        <div
                fxFlex="100"
                fxFlex.gt-sm="100"
                style="max-width: 100%; justify-content: center"
        >
            <app-etat-mandataire-four
                    *ngIf="dataMandSoum"
                    [certif]="dataMandSoum"

                    [isetrangere]="dataG[0]?.national!=='TUN'"
            ></app-etat-mandataire-four>
        </div>
    </mat-card-content>
</mat-card>
<br/>

<app-fiche-consultation
        [dataColumnsAr]="dataColumnsDeroulAr"
        [dataColumnsEn]="dataColumnsDeroulEn"
        [dataColumns]="dataColumnsDeroulFr"
        [data]="dataG"
        [label]="'Etat Déroulement'"
        [labels]="labelsDeroul"
        [langue]="getlang()"
>
</app-fiche-consultation>

<div fxLayoutAlign="end end">
    <div fxLayoutAlign="end end" style="padding-top: 2.5%">
        <button
                (click)="retourListe()"
                mat-raised-button
                style="background-color: #3e90d0; color: white"
        >
            <span translate>List</span>
        </button>
    </div>
    <div
            *ngIf="
      dataDoc[0]?.excStat != 1 &&
      dataDoc[0]?.excStat != 4 &&
      dataDoc[0]?.excStat != 6 &&
      dataDoc[0]?.excStat != 0 &&
      dataDoc[0]?.excStat != 8
    "
            fxLayoutAlign="end end"
            style="padding-top: 2.5%; padding-left: 1.5%"
    >
        <button (click)="supprimer()" color="primary" mat-raised-button>
            <span translate>Annuler Demande</span>
        </button>
    </div>
    <div
            *ngIf="dataDoc[0]?.excStat == 9 || dataDoc[0]?.excStat == 6"
            fxLayoutAlign="end end"
            style="padding-top: 2.5%; padding-left: 1.5%"
    >
        <button (click)="signer()" color="primary" mat-raised-button>
            <span translate>Signer Demande Enregistrement</span>
        </button>
    </div>

    <div
            *ngIf="dataDoc[0]?.excStat == 5 || dataDoc[0]?.excStat == 8"
            fxLayoutAlign="end end"
            style="padding-top: 2.5%; padding-left: 1.5%"
    >
        <button (click)="signer()" color="primary" mat-raised-button>
            <span translate>Réenvoyer</span>
        </button>
    </div>
</div>
<ng-container *ngIf="show">
    <div class="cp5 p-3 " fxLayout="row wrap" fxLayoutAlign="start center ">
        <div fxFlex="100">

            <app-certificat-page #content (emitdata)="send($event)" [portail]="false"></app-certificat-page>
        </div>

    </div>
</ng-container>
